import { ColorIndicator } from "@/components/color-indicator/ColorIndicator";
import { Flex, Text } from "@chakra-ui/react";
import { v4 } from "uuid";

interface Props {
  radioItems: { label: string; color: string }[];
}

export const CheckRequestDetailLegend = ({ radioItems }: Props) => {
  return (
    <Flex alignItems="center" gap="30px">
      <Text
        fontWeight={700}
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            fontSize: "12px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            fontSize: "14px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            fontSize: "16px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            fontSize: "18px",
          },
          "@media (max-width: 1900px)": {
            fontSize: "20px",
          },
        }}
      >
        Detalle
      </Text>

      {radioItems.map((item) => (
        <Flex key={v4()} alignItems="center" gap="10px" justifyContent="center">
          <ColorIndicator color={item.color} size="14px" />
          <Text
            css={{
              "@media (max-width: 1350px) and (min-width: 1272px)": {
                fontSize: "12px",
              },
              "@media (max-width: 1414px) and (min-width: 1351px)": {
                fontSize: "14px",
              },
              "@media (max-width: 1590px) and (min-width: 1415px)": {
                fontSize: "14px",
              },
              "@media (max-width: 1696px) and (min-width: 1591px)": {
                fontSize: "16px",
              },
              "@media (max-width: 1900px)": {
                fontSize: "16px",
              },
            }}
          >
            {item.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};
